var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckFalseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.6665C14.6025 1.6665 18.3334 5.39734 18.3334 9.99984C18.3334 14.6023 14.6025 18.3332 10 18.3332C5.39752 18.3332 1.66669 14.6023 1.66669 9.99984C1.66669 5.39734 5.39752 1.6665 10 1.6665ZM10 3.33317C8.23191 3.33317 6.53622 4.03555 5.28598 5.28579C4.03573 6.53603 3.33335 8.23173 3.33335 9.99984C3.33335 11.7679 4.03573 13.4636 5.28598 14.7139C6.53622 15.9641 8.23191 16.6665 10 16.6665C11.7681 16.6665 13.4638 15.9641 14.7141 14.7139C15.9643 13.4636 16.6667 11.7679 16.6667 9.99984C16.6667 8.23173 15.9643 6.53603 14.7141 5.28579C13.4638 4.03555 11.7681 3.33317 10 3.33317Z",
    fill: "url(#paint0_linear_6972_6111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6972_6111",
    x1: 18.3334,
    y1: 1.6665,
    x2: 1.66669,
    y2: 19.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFalseIcon);
export default __webpack_public_path__ + "static/media/checkFalseIcon.675aa2bdb5ddf0450f6455dfa021440b.svg";
export { ForwardRef as ReactComponent };